import { objectProto } from './context'
const { hasOwnProperty: contextHasOwnProperty } = objectProto
export default contextHasOwnProperty
